import script from "./Service.vue?vue&type=script&setup=true&lang=js"
export * from "./Service.vue?vue&type=script&setup=true&lang=js"

import "./Service.vue?vue&type=style&index=0&id=0dbd6c7c&scoped=true&lang=less"
import "./Service.vue?vue&type=style&index=1&id=0dbd6c7c&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dbd6c7c"]])

export default __exports__